import { authHeader, history } from "../_helpers";
import config from "../config";
import axios from "axios";
export const samanService = {
  createSamanInformation,
  getSamansInformation,
  updatePSSide,
};

const baseUrl = config.apiGateway.baseUrl;
// const baseUrl = "https://www.criminalmis.in/api";

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("user");
  history.push("login");
}

function handleResponse(response) {
  if (response.status === 401) {
    // auto logout if 401 response returned from api
    logout();
    // location.reload(true);
  }

  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

function createSamanInformation(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/criminal/createsummons`, requestOptions).then(
    handleResponse
  );
}

function getSamansInformation() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/criminal/getallsummons`, requestOptions).then(
    handleResponse
  );
}

function updatePSSide(data, id) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(
    `${baseUrl}/criminal/usdatesummonpsside/${id}`,
    requestOptions
  ).then(handleResponse);
}
